import React, { useState, useEffect } from 'react';
import { supabase } from './supabaseClient';
import { QadderLogo } from './Logo';

const BATCH_SIZE = 100;
const STORAGE_KEY = 'qadder_circles_progress';

function loadProgress() {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'); }
  catch { return {}; }
}

function saveProgress(data) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

// حالة الدائرة: not_started | in_progress | completed
function getCircleState(progress, key) {
  const p = progress[key];
  if (!p) return 'not_started';
  if (p.completed) return 'completed';
  if (p.answered > 0) return 'in_progress';
  return 'not_started';
}

function CircleCard({ circle, onClick }) {
  const state = circle.state;
  const p = circle.progress;

  const colors = {
    not_started: { bg: '#1e293b', border: '#334155', text: '#64748b', icon: '⭕' },
    in_progress: { bg: '#1e3a5f', border: '#3b82f6', text: '#93c5fd', icon: '🔄' },
    completed:   { bg: '#14532d', border: '#22c55e', text: '#86efac', icon: '✅' },
  };
  const c = colors[state];

  const pct = p ? Math.round((p.correct / (p.answered || 1)) * 100) : 0;

  return (
    <button
      onClick={onClick}
      style={{
        background: c.bg,
        border: `2px solid ${c.border}`,
        borderRadius: '50%',
        width: 90, height: 90,
        cursor: 'pointer',
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        fontFamily: 'Tajawal,sans-serif',
        transition: 'all 0.2s',
        position: 'relative',
        padding: 0,
      }}
      onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.08)'; }}
      onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}
    >
      {state === 'completed' ? (
        <>
          <div style={{ fontSize: 11, fontWeight: 900, color: '#86efac' }}>{pct}%</div>
          <div style={{ fontSize: 9, color: '#4ade80' }}>✓{p.correct} ✗{p.wrong}</div>
          <div style={{ fontSize: 9, color: '#86efac', marginTop: 2 }}>#{circle.num}</div>
        </>
      ) : state === 'in_progress' ? (
        <>
          <div style={{ fontSize: 11, fontWeight: 900, color: '#93c5fd' }}>{p?.answered || 0}</div>
          <div style={{ fontSize: 9, color: '#60a5fa' }}>/{BATCH_SIZE}</div>
          <div style={{ fontSize: 9, color: '#93c5fd', marginTop: 2 }}>#{circle.num}</div>
        </>
      ) : (
        <>
          <div style={{ fontSize: 13, fontWeight: 900, color: '#94a3b8' }}>{circle.ids.length}</div>
          <div style={{ fontSize: 9, color: '#64748b' }}>سؤال</div>
          <div style={{ fontSize: 9, color: '#475569', marginTop: 1 }}>#{circle.num}</div>
        </>
      )}

      {/* شريط تقدم دائري */}
      {state !== 'not_started' && (
        <svg style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
          viewBox="0 0 90 90">
          <circle cx="45" cy="45" r="42" fill="none" stroke={c.border + '33'} strokeWidth="3" />
          <circle cx="45" cy="45" r="42" fill="none" stroke={c.border}
            strokeWidth="3" strokeLinecap="round"
            strokeDasharray={`${2 * Math.PI * 42}`}
            strokeDashoffset={`${2 * Math.PI * 42 * (1 - (p?.answered || 0) / BATCH_SIZE)}`}
            transform="rotate(-90 45 45)"
            style={{ transition: 'stroke-dashoffset 0.5s' }}
          />
        </svg>
      )}
    </button>
  );
}

const SUBJECT_LABELS = {
  'كمي': { label: 'قدرات — كمي', icon: '🔢', color: '#3b82f6' },
  'لفظي': { label: 'قدرات — لفظي', icon: '📖', color: '#7c6df8' },
  'رياضيات': { label: 'تحصيلي — رياضيات', icon: '📐', color: '#3b82f6' },
  'فيزياء': { label: 'تحصيلي — فيزياء', icon: '⚡', color: '#f59e0b' },
  'كيمياء': { label: 'تحصيلي — كيمياء', icon: '⚗️', color: '#10b981' },
  'أحياء': { label: 'تحصيلي — أحياء', icon: '🧬', color: '#ec4899' },
};
const ALL_QUDURAT = { label: 'قدرات — كمي + لفظي', icon: '🧠', color: '#7c6df8' };
const ALL_TAHSILI = { label: 'تحصيلي — جميع المواد', icon: '🎓', color: '#10b981' };

function SubscribeModal({ onPlans, onClose }) {
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 1000,
      background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(6px)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 24, fontFamily: 'Tajawal,sans-serif', direction: 'rtl',
    }} onClick={onClose}>
      <div style={{
        background: 'var(--bg-card)',
        border: '1.5px solid rgba(232,121,249,0.4)',
        borderRadius: 24, padding: '32px 28px', maxWidth: 360, width: '100%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
        textAlign: 'center',
      }} onClick={e => e.stopPropagation()}>
        <div style={{ fontSize: 52, marginBottom: 12 }}>🔒</div>
        <h2 style={{ color: '#e879f9', fontSize: 20, fontWeight: 800, margin: '0 0 10px' }}>
          هذه الدائرة للمشتركين
        </h2>
        <p style={{ color: 'var(--text-secondary)', fontSize: 14, lineHeight: 1.8, margin: '0 0 24px' }}>
          اشترك في باقة قادر للوصول إلى جميع الدوائر وآلاف الأسئلة المنظّمة
        </p>
        <button
          onClick={onPlans}
          style={{
            width: '100%', padding: '14px', borderRadius: 12,
            background: 'linear-gradient(135deg, #c026d3, #e879f9)',
            border: 'none', color: '#fff', fontSize: 16, fontWeight: 700,
            fontFamily: 'Tajawal,sans-serif', cursor: 'pointer',
            boxShadow: '0 6px 20px rgba(232,121,249,0.35)',
            marginBottom: 10,
          }}
        >
          🚀 اشترك الآن
        </button>
        <button
          onClick={onClose}
          style={{
            width: '100%', padding: '10px', borderRadius: 12,
            background: 'none', border: '1px solid var(--border)',
            color: 'var(--text-muted)', fontSize: 14,
            fontFamily: 'Tajawal,sans-serif', cursor: 'pointer',
          }}
        >
          لاحقاً
        </button>
      </div>
    </div>
  );
}

export default function CirclesScreen({ mode, subjects, plan, onStartBatch, onBack, onPlans }) {
  const [questions, setQuestions]   = useState([]);
  const [loading, setLoading]       = useState(true);
  const [progress, setProgress]     = useState(loadProgress());
  const [reportCircle, setReportCircle] = useState(null); // للتقرير الشامل
  const [showSubscribe, setShowSubscribe] = useState(false);

  const progressKey = (num) => `${mode}_${subjects.join('_')}_${num}`;

  const sectionInfo = subjects.length > 1
    ? (subjects.includes('كمي') ? ALL_QUDURAT : ALL_TAHSILI)
    : (SUBJECT_LABELS[subjects[0]] || { label: subjects[0], icon: '📚', color: '#7c6df8' });

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      let all = [];
      let from = 0;
      const PAGE = 1000;
      while (true) {
        const { data } = await supabase
          .from('questions')
          .select('id, subject')
          .in('subject', subjects)
          .eq('is_active', true)
          .order('id')
          .range(from, from + PAGE - 1);
        if (!data || data.length === 0) break;
        all = [...all, ...data];
        if (data.length < PAGE) break;
        from += PAGE;
      }
      setQuestions(all);
      setLoading(false);
    };
    load();
  }, [mode, subjects.join(',')]); // eslint-disable-line

  const circles = [];
  for (let i = 0; i < questions.length; i += BATCH_SIZE) {
    const num = Math.floor(i / BATCH_SIZE) + 1;
    const key = progressKey(num);
    circles.push({
      num,
      ids: questions.slice(i, i + BATCH_SIZE).map(q => q.id),
      state: getCircleState(progress, key),
      progress: progress[key] || null,
    });
  }

  const stats = {
    total: circles.length,
    completed: circles.filter(c => c.state === 'completed').length,
    inProgress: circles.filter(c => c.state === 'in_progress').length,
  };

  const handleCircleClick = async (circle) => {
    // تحقق حي من الاشتراك مباشرة من Supabase
    const { data: { user: authUser } } = await supabase.auth.getUser();
    if (authUser) {
      const { data: sub } = await supabase
        .from('subscriptions')
        .select('id')
        .eq('user_id', authUser.id)
        .eq('status', 'active')
        .gt('expires_at', new Date().toISOString())
        .limit(1)
        .maybeSingle();
      if (!sub) {
        setShowSubscribe(true);
        return;
      }
    } else {
      setShowSubscribe(true);
      return;
    }
    // إذا مكتملة → اعرض التقرير الشامل
    if (circle.state === 'completed') {
      setReportCircle(circle);
      return;
    }
    const key = progressKey(circle.num);
    onStartBatch({
      ids: circle.ids,
      circleNum: circle.num,
      progressKey: key,
      onUpdate: (answered, correct, wrong, completed) => {
        const newP = { answered, correct, wrong, completed };
        const updated = { ...loadProgress(), [key]: newP };
        saveProgress(updated);
        setProgress(updated);
      }
    });
  };

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--bg-page)',
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      padding: '24px 16px 40px', fontFamily: 'Tajawal,sans-serif', direction: 'rtl',
    }}>
      {showSubscribe && (
        <SubscribeModal
          onPlans={() => { setShowSubscribe(false); onPlans && onPlans(); }}
          onClose={() => setShowSubscribe(false)}
        />
      )}
      <div style={{ width: '100%', maxWidth: 480 }}>

        {/* هيدر */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
          <QadderLogo onHome={onBack} size={32} />
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span style={{ fontSize: 22 }}>{sectionInfo.icon}</span>
            <span style={{ color: sectionInfo.color, fontWeight: 800, fontSize: 15 }}>{sectionInfo.label}</span>
          </div>
          <button onClick={onBack} style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 10, padding: '7px 14px', color: 'var(--text-secondary)', fontSize: 13, cursor: 'pointer' }}>← رجوع</button>
        </div>

        {/* إحصائيات */}
        {!loading && (
          <div style={{ display: 'flex', gap: 10, marginBottom: 24 }}>
            {[
              { label: 'الكل', value: stats.total, color: '#64748b' },
              { label: 'مكتملة', value: stats.completed, color: '#22c55e' },
              { label: 'جاري', value: stats.inProgress, color: '#3b82f6' },
              { label: 'متبقي', value: stats.total - stats.completed - stats.inProgress, color: '#f59e0b' },
            ].map(s => (
              <div key={s.label} style={{ flex: 1, background: 'var(--bg-card)', border: `1px solid ${s.color}33`, borderRadius: 12, padding: '10px 6px', textAlign: 'center' }}>
                <div style={{ color: s.color, fontWeight: 900, fontSize: 20 }}>{s.value}</div>
                <div style={{ color: 'var(--text-muted)', fontSize: 11 }}>{s.label}</div>
              </div>
            ))}
          </div>
        )}

        {/* مفتاح الألوان */}
        <div style={{ display: 'flex', gap: 16, marginBottom: 20, justifyContent: 'center', flexWrap: 'wrap' }}>
          {[
            { color: '#334155', label: 'لم تبدأ' },
            { color: '#3b82f6', label: 'جاري' },
            { color: '#22c55e', label: 'مكتملة' },
          ].map(l => (
            <div key={l.label} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
              <div style={{ width: 12, height: 12, borderRadius: '50%', background: l.color }} />
              <span style={{ color: 'var(--text-muted)', fontSize: 12 }}>{l.label}</span>
            </div>
          ))}
        </div>

        {/* عنوان توضيحي */}
        {!loading && circles.length > 0 && (
          <div style={{ textAlign: 'center', marginBottom: 16, padding: '14px 20px', background: 'rgba(124,109,248,0.08)', border: '1px solid rgba(124,109,248,0.2)', borderRadius: 14 }}>
            <p style={{ color: '#a78bfa', fontWeight: 700, fontSize: 14, margin: '0 0 4px' }}>
              🎯 اختر دائرة للبدء
            </p>
            <p style={{ color: 'var(--text-muted)', fontSize: 12, margin: '0 0 8px' }}>
              كل دائرة تحتوي على <strong style={{ color: 'var(--text-secondary)' }}>{BATCH_SIZE} سؤال</strong> — اختر من حيث توقفت
            </p>
            <div style={{
              background: 'rgba(34,197,94,0.1)', border: '1px solid rgba(34,197,94,0.3)',
              borderRadius: 10, padding: '8px 14px',
            }}>
              <p style={{ color: '#22c55e', fontSize: 12, margin: 0, fontWeight: 700 }}>
                ✅ بعد إنهاء الدائرة — اضغط عليها مجدداً لعرض تقرير أدائك التفصيلي
              </p>
            </div>
          </div>
        )}

        {/* الدوائر */}
        {loading ? (
          <p style={{ color: 'var(--text-muted)', textAlign: 'center' }}>جاري التحميل...</p>
        ) : (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, justifyContent: 'center' }}>
            {circles.map(circle => (
              <CircleCard
                key={circle.num}
                circle={circle}
                onClick={() => handleCircleClick(circle)}
              />
            ))}
          </div>
        )}

        {circles.length === 0 && !loading && (
          <p style={{ color: 'var(--text-muted)', textAlign: 'center', marginTop: 40 }}>لا توجد أسئلة</p>
        )}
      </div>

      {/* التقرير الشامل — Modal */}
      {reportCircle && reportCircle.progress && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 1000, padding: 20, fontFamily: 'Tajawal,sans-serif', direction: 'rtl',
        }} onClick={() => setReportCircle(null)}>
          <div style={{
            background: 'var(--bg-card)', borderRadius: 24, padding: 28,
            width: '100%', maxWidth: 380, border: '2px solid #22c55e44',
          }} onClick={e => e.stopPropagation()}>

            {/* العنوان */}
            <div style={{ textAlign: 'center', marginBottom: 20 }}>
              <div style={{ fontSize: 48, marginBottom: 8 }}>🏆</div>
              <h3 style={{ color: '#86efac', fontSize: 20, fontWeight: 900, margin: '0 0 4px' }}>
                الدائرة #{reportCircle.num} — مكتملة
              </h3>
              <p style={{ color: 'var(--text-muted)', fontSize: 13, margin: 0 }}>
                {sectionInfo.icon} {sectionInfo.label}
              </p>
            </div>

            {/* إحصائيات */}
            {(() => {
              const p = reportCircle.progress;
              const pct = Math.round((p.correct / (p.answered || 1)) * 100);
              const color = pct >= 80 ? '#22c55e' : pct >= 60 ? '#f59e0b' : '#ef4444';
              return (
                <>
                  {/* النسبة الكبيرة */}
                  <div style={{ textAlign: 'center', marginBottom: 20 }}>
                    <div style={{ fontSize: 56, fontWeight: 900, color }}>{pct}%</div>
                    <div style={{ color: 'var(--text-muted)', fontSize: 13 }}>نسبة الإجابات الصحيحة</div>
                  </div>

                  {/* تفاصيل */}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 10, marginBottom: 20 }}>
                    {[
                      { label: 'الإجمالي', value: p.answered, color: '#94a3b8', icon: '📋' },
                      { label: 'صحيح', value: p.correct, color: '#22c55e', icon: '✅' },
                      { label: 'خطأ', value: p.wrong, color: '#ef4444', icon: '❌' },
                    ].map(s => (
                      <div key={s.label} style={{ background: `${s.color}11`, border: `1px solid ${s.color}33`, borderRadius: 12, padding: '12px 8px', textAlign: 'center' }}>
                        <div style={{ fontSize: 18 }}>{s.icon}</div>
                        <div style={{ color: s.color, fontWeight: 900, fontSize: 22 }}>{s.value}</div>
                        <div style={{ color: 'var(--text-muted)', fontSize: 11 }}>{s.label}</div>
                      </div>
                    ))}
                  </div>

                  {/* رسالة تشجيعية */}
                  <div style={{ background: `${color}11`, border: `1px solid ${color}33`, borderRadius: 12, padding: '10px 14px', textAlign: 'center', marginBottom: 16 }}>
                    <p style={{ color, fontWeight: 700, fontSize: 14, margin: 0 }}>
                      {pct >= 90 ? '🌟 ممتاز! أداء رائع جداً' :
                       pct >= 75 ? '💪 جيد جداً! استمر' :
                       pct >= 60 ? '📈 فوق المتوسط — واصل' :
                       '🎯 راجع الأخطاء وكرر الدائرة'}
                    </p>
                  </div>
                </>
              );
            })()}

            {/* أزرار */}
            <div style={{ display: 'flex', gap: 10 }}>
              <button
                onClick={() => { setReportCircle(null); handleCircleClick({ ...reportCircle, state: 'in_progress' }); }}
                style={{ flex: 1, background: '#22c55e22', border: '1px solid #22c55e44', borderRadius: 12, padding: 12, color: '#86efac', fontWeight: 700, fontSize: 14, cursor: 'pointer', fontFamily: 'Tajawal,sans-serif' }}
              >
                🔄 إعادة الدائرة
              </button>
              <button
                onClick={() => setReportCircle(null)}
                style={{ flex: 1, background: 'var(--bg-card-alt)', border: '1px solid var(--border)', borderRadius: 12, padding: 12, color: 'var(--text-secondary)', fontWeight: 700, fontSize: 14, cursor: 'pointer', fontFamily: 'Tajawal,sans-serif' }}
              >
                ← رجوع
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
